import { useSyncExternalStore } from 'react';

export const makeMediaQuery = () => (mediaQuery: string, defaultValue = false)=> {
  const isClient = typeof window !== 'undefined';
  function getSnapshot() {
    return isClient ? window.matchMedia(mediaQuery).matches : false;
  }
  function subscribe(callback: () => void) {
    if (!isClient) return;
    const mediaQueryList = window.matchMedia(mediaQuery);
    mediaQueryList.addEventListener('change', callback);
    return () => mediaQueryList.removeEventListener('change', callback);
  }

  function getServerSnapshot() {
    return defaultValue;
  }

  return function useMediaQuery() {
    return useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
  }();
};
